import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = ({ data }) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(data)}
      </script>
    </Helmet>
  );
};

// Helper function to create NewsArticle structured data
export const createNewsArticleSchema = ({
  title,
  description,
  imageUrl,
  author,
  publishedDate,
  modifiedDate,
  category,
  url,
}) => {
  const baseUrl = window.location.origin;
  const fullUrl = url ? `${baseUrl}${url}` : window.location.href;
  const fullImage = imageUrl && imageUrl.startsWith('http') ? imageUrl : `${baseUrl}${imageUrl || '/images/logo-rr-news.png'}`;

  return {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    "headline": title,
    "description": description,
    "image": [fullImage],
    "datePublished": publishedDate,
    "dateModified": modifiedDate || publishedDate,
    "author": {
      "@type": "Person",
      "name": author || "RR NEWS TV FASTEST UPDATE",
    },
    "publisher": {
      "@type": "Organization",
      "name": "RR NEWS TV FASTEST UPDATE",
      "logo": {
        "@type": "ImageObject",
        "url": `${baseUrl}/images/logo-rr-news.png`
      }
    },
    "articleSection": category,
    "inLanguage": "hi-IN",
    "url": fullUrl,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": fullUrl
    }
  };
};

// Helper function to create WebSite structured data
export const createWebSiteSchema = () => {
  const baseUrl = window.location.origin;
  
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "RR NEWS TV FASTEST UPDATE",
    "alternateName": "RR News TV",
    "url": baseUrl,
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${baseUrl}/search?q={search_term_string}`,
      "query-input": "required name=search_term_string"
    },
    "inLanguage": "hi-IN"
  };
};

// Helper function to create Organization structured data
export const createOrganizationSchema = () => {
  const baseUrl = window.location.origin;
  
  return {
    "@context": "https://schema.org",
    "@type": "NewsMediaOrganization",
    "name": "RR NEWS TV FASTEST UPDATE",
    "alternateName": "RR NEWS TV FASTEST UPDATE",
    "url": baseUrl,
    "logo": `${baseUrl}/images/logo-rr-news.png`,
    "description": "RR NEWS TV FASTEST UPDATE - देश-विदेश की ताज़ा खबरें, ब्रेकिंग न्यूज़",
    "sameAs": [
      "https://www.facebook.com/rrnewstv",
      "https://twitter.com/rrnewstv",
      "https://www.instagram.com/rrnewstv"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "Customer Service",
      "availableLanguage": ["Hindi", "English"]
    }
  };
};

// Helper function to create BreadcrumbList structured data
export const createBreadcrumbSchema = (items) => {
  const baseUrl = window.location.origin;
  
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url ? `${baseUrl}${item.url}` : undefined
    }))
  };
};

export default StructuredData;


